import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Relayout, RelayoutItem } from 'relayout'

import Field from 'components/grid-form-field'
import Input from 'components/grid-form-input'
import Error from 'components/grid-form-error'
import PrimaryButton from 'components/primary-button'
import SecondaryButton from 'components/secondary-button'

import styles from './promo-code-form.css'

const PromoCodeForm = ({ fields, onCancelClick, handleSubmit }) => (
  <form styleName="promo-code-form">
    <Relayout>
      <RelayoutItem sm="12" lg="12">
        <Field field={fields.name} label="Code Name">
          <Input />
          <Error />
        </Field>
      </RelayoutItem>

      <RelayoutItem sm="12" lg="6">
        <Field field={fields.pcType} label="Discount Type">
          <Input />
          <Error />
        </Field>
      </RelayoutItem>
      <RelayoutItem sm="12" lg="6">
        <Field field={fields.value} label="Discount Value">
          <Input />
          <Error />
        </Field>
      </RelayoutItem>

      <RelayoutItem sm="12" lg="6">
        <Field field={fields.onsaleTime} label="Valid From">
          <Input />
          <Error />
        </Field>
      </RelayoutItem>
      <RelayoutItem sm="12" lg="6">
        <Field field={fields.offsaleTime} label="Valid To">
          <Input />
          <Error />
        </Field>
      </RelayoutItem>

      <RelayoutItem sm="12" lg="4">
        <Field field={fields.totalLimit} label="Total Limit">
          <Input />
          <Error />
        </Field>
      </RelayoutItem>
      <RelayoutItem sm="12" lg="4">
        <Field field={fields.limitPerCustomer} label="Limit Per Customer">
          <Input />
          <Error />
        </Field>
      </RelayoutItem>

      <RelayoutItem sm="12" lg="12">
        <div styleName="actions">
          <div styleName="button">
            <SecondaryButton label="Cancel" onClick={onCancelClick} />
          </div>
          <div styleName="button">
            <PrimaryButton label="Save" onClick={handleSubmit} />
          </div>
        </div>
      </RelayoutItem>
    </Relayout>
  </form>
)

PromoCodeForm.propTypes = {
  fields: PropTypes.object.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
}

export default CSSModules(PromoCodeForm, styles)



/** WEBPACK FOOTER **
 ** ./src/components/promo-code-form/promo-code-form.js
 **/